const translations = {
    title: 'Notes'
};

export default translations;
